// import alle from "../resources/vorstand/04_vorstandschaft.jpg";
// import chrissi from "../resources/vorstand/Chrissi.JPG";
// import matthias from "../resources/vorstand/Matthias.png";
import Logo from "../resources/logo.svg";

function Vorstandschaft() {

    const Chrissi = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/vorstand/Chrissi.JPG"
            alt="Chrissi"
            className="img_vorstand"
        />
      );
      const Matthias = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/vorstand/Matthias.png"
            alt="Matthias"
            className="img_vorstand"
        />
      );

      const Alle = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/vorstand/Vorstand_2025"
            alt="Vorstandschaft"
            className="col-8"
        />
      );

    return (
        <div className="Vorstandschaft">

            <div className="horizontalDiv row">
            <p className="pagecontent">DIE VORSTANDSCHAFT</p>
            </div>

            <div className="row">
                <div className="verticalDiv col-sm-6">
                    {/* <img alt="Bild1" className="img_vorstand" src={chrissi}></img> */}
                    <Chrissi></Chrissi>
                    <p className="heading_midsize">1.Vorstand</p>
                    <p className="heading_smallsize">Christina Schieber</p>
                </div>
                <div className="verticalDiv col-sm-6">
                    {/* <img alt="Bild2" className="img_vorstand" src={matthias}></img> */}
                    <Matthias></Matthias>
                    <p className="heading_midsize">2. Vorstand</p>
                    <p className="heading_smallsize">Matthias Heigl</p>
                </div>
            </div>

           

            <div className="row">
                <div className="verticalDiv col-sm-6">
                    <p className="heading_midsize">Kassiere</p>
                    <p>1. Bettina Turner</p>
                    <p>2. Jessica Meier</p>
                </div>
                <div className="verticalDiv col-sm-6">
                <p className="heading_midsize">Schriftführer</p>
                    <p>1. Stefanie Eder</p>
                    <p>2. Lena Heinrich</p>
                </div>
                <div className="verticalDiv col">
                    <p className="heading_midsize">Beisitzer</p>
                    <p>Katja Schieber, Theresa Reißner, Brigitte Schieber, Daniela Heigl, Susanne Heigl, Gerda Müller, Markus Schneider, Leonie Vogl,
                         Martina Luidl, Kevin Miedaner, Marlene Guppenberger, Jana Luidl, Andrea Vogl, Sabrina Medele, Carolin Koller, Hans Greißinger </p>
                </div>
            </div>

            <div className="horizontalDiv row">
                 {/* <img className="col-8" src={alle}></img> */}
                 <Alle></Alle>
            </div>
           
            
            <div className="row justify-content-sm-center" style={{ textAlign: 'center' }}>
          <img src={Logo} className="imageResize"></img>
        </div>

        </div>
    );
}

export default Vorstandschaft;